interface DevBackend {
	instance: string;
	origin: string;
}

// Vite defines both values (validated in src/util/devServerPin.ts) when a local dev stack pins the dev server to one backend.
export const devBackend = (): DevBackend | null => {
	const instance = process.env.IFS_DEV_BACKEND_INSTANCE ?? '';
	const origin = process.env.IFS_DEV_BACKEND_ORIGIN ?? '';
	return instance !== '' && origin !== '' ? { instance, origin } : null;
};
